<template>
    <div class="import-show-confirm-screen">
        <h2 class="title">
            Confirm Your Podcast Details
        </h2>

        <p class="description">
            Here's what we found using your RSS feed.<br>
            Review and confirm the information below.
        </p>

        <div class="show">
            <div class="showCover">
                <img v-if="show.cover" :src="show.cover.imageUrl" alt="Cover">
            </div>

            <ul class="showData">
                <li><strong>Title</strong>: {{ show.title }}</li>
                <li><strong>Host</strong>: {{ show.artist }}</li>
                <li>
                    <strong>Genre</strong>:
                    {{ show.categories && show.categories.length > 0 ? show.categories.join(', ') : '-' }}
                </li>
                <li><strong># of Episodes</strong>: {{ show.episodeCount }}</li>
                <li><strong>Contact Email</strong>: {{ show.contactEmail }}</li>
            </ul>
        </div>

        <div class="help">
            Need to make a change?<br>
            Please update your podcast inside your hosts' dashboard.
        </div>

        <button class="form-button is-purple" @click="onContinue">
            Confirm & Choose Plan
        </button>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import apiCall from '@/utils/apiCall';

export default {
    props: {
        onContinue: {
            required: true,
            type: Function,
        },
    },

    data: () => ({
        isSubmitting: false,
        feedUrl: '',
    }),

    computed: {
        ...mapState('show/modal', ['show']),
    },

    methods: {
        /**
         * Handles submit.
         */
        async handleSubmit() {
            if (! await this.validate()) {
                return;
            }

            this.isSubmitting = true;
            const { status, data } = await apiCall(this, 'post', '/api/shows/import', { feedUrl: this.feedUrl });
            this.isSubmitting = false;

            if (400 <= status) {
                this.populateValidationErrors(data.errors ?? {});

                return;
            }

            this.onSubmit(data);
        },

    },
};
</script>
<style scoped lang="scss">
    @use './ImportShowConfirmScreen.scss';
</style>
